// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-container .form-item[data-v-e13caece]{padding-bottom:0}.remark[data-v-e13caece]{font-size:14px;line-height:30px;color:rgba(0,0,0,.85);position:relative;top:20px;padding-left:30px}.rangePrice .el-form-item[data-v-e13caece]{width:170px;float:left}.tip2[data-v-e13caece]{width:100%;margin-top:4px;color:red}", ""]);
// Exports
module.exports = exports;
